import './App.css';
import './index.css';

import { StyledEngineProvider } from '@mui/material/styles';
import { useEffect } from "react";
//import axiosExt from './axios';
import { Routes, Route } from "react-router-dom";
//import i18n from "./i18n";
import { SnackbarProvider } from 'notistack';
import { useNavigate } from "react-router-dom";
import { setGlobalNavigate } from "./axios";
//import jwtDecode from 'jwt-decode';
//import dayjs from 'dayjs';
//import { getToken, setToken, clearToken } from 'tokenService';

import CustomersPage from "./pages/CustomersPage";
import CustomerPricingPage from "./pages/CustomerPricingPage";
import ServicePricingPage from "./pages/ServicePricingPage";
import ContactsPage from "./pages/ContactsPage";
import OrdersPage from "./pages/OrdersPage";
import UsersManagementPage from "./pages/UsersManagementPage";
import MessageTemplatesPage from "./pages/MessageTemplatesPage";
import IgnoreListPage from "./pages/IgnoreListPage";
import LoginPage from "./pages/LoginPage";
import NavigationPage from "./pages/NavigationPage";
import ProtectedRoute from "./components/ProtectedRoute";
import EmailListPage from "./pages/EmailListPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import ServicesPage from "./pages/ServicesPage";
import OrderTypesPage from "./pages/OrderTypesPage";
import OrderStatesPage from "./pages/OrderStatesPage";
import TaxTypeMappingsPage from "./pages/TaxTypeMappingsPage.tsx";
import DetailStatesPage from "./pages/DetailStatesPage";
import OrderDetailsPage from "./pages/OrderDetailsPage";
import OrderDetailsCustomerPage from "./pages/OrderDetailsCustomerPage";
import AccountingTranslationsPage from "./pages/AccountingTranslationsPage";    
import PricingPage from "./pages/PricingPage";    
import CountriesPage from "./pages/CountriesPage";
import EmailConnectionPage from "./pages/EmailConnectionPage";

import SurveyPage from "./pages/SurveyPage";
import SurveyResultsPage from "./pages/SurveyResultsPage";
import ReportSurveyNpsPage from "./pages/ReportSurveyNpsPage"
import ReportCustomerOrdersNoPage from "./pages/ReportCustomerOrdersNoPage"
import RemindersPage from "./pages/RemindersPage"

import ReportOrdersStatus from "./pages/ReportOrdersStatusPage";
import ReportOrdersStatusByAssigned from "./pages/ReportOrdersStatusByAssignedPage";

import { API_BASE_URL } from "./config.ts";

//import { LocalizationProvider } from "@mui/x-date-pickers";
//import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';

import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey('eb12283f9c630eede644877dc0595d8cTz0xMjY3OTUsRT0xODA0ODA5NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=');

const App: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        setGlobalNavigate(navigate);
    }, [navigate]);

    //useEffect(() => {
    //    const fetchUserLanguage = async () => {
    //        try {
    //            const response = await axiosExt.get(`${API_BASE_URL}/user/language`, {
    //                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    //            });
    //            const userLang = response.data.language;
    //            if (userLang) {
    //                i18n.changeLanguage(userLang);
    //            }
    //        } catch (error) {
    //            console.error("Could not fetch user language", error);
    //        }
    //    };

    //    if (localStorage.getItem("token")) {
    //        fetchUserLanguage();
    //    }
    //}, []);

    useEffect(() => {
        const interval = setInterval(async () => {
            const token = localStorage.getItem("token");
            if (!token) return;

            try {
                const { exp } = JSON.parse(atob(token.split('.')[1])); // decode token payload
                const expiration = exp * 1000;
                const isExpiringSoon = expiration - Date.now() < 5 * 60 * 1000; // 5 min

                if (isExpiringSoon) {
                    console.log("Refreshing token...");
                    
                    const res = await fetch(`${API_BASE_URL}/auth/refresh`, {
                        method: "POST",
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    });

                    if (!res.ok) throw new Error("Refresh failed");

                    const data = await res.json();
                    localStorage.setItem("token", data.token);
                    console.log("Token refreshed");
                }
            } catch {
                console.warn("Token refresh failed, logging out");
                localStorage.removeItem("token");
                window.location.href = "/"; // or "/login"
            }
        }, 300_000); // check every 5 minutes

        return () => clearInterval(interval);
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <SnackbarProvider maxSnack={3} autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
            <CssBaseline />
        <StyledEngineProvider injectFirst>
            <Routes>
                {/* Default route is the login page */}
                <Route path="/" element={<LoginPage />} />
                <Route path="/survey/:orderId/:contactId?" element={<SurveyPage />} />
                {/* Protected navigation page */}
                <Route path="/navigation" 
                    element={
                        <ProtectedRoute>
                            <NavigationPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/emails"
                    element={
                        <ProtectedRoute>
                            <EmailListPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/invoices"
                    element={
                        <ProtectedRoute>
                            <InvoiceListPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/customers"
                    element={
                        <ProtectedRoute>
                            <CustomersPage />
                        </ProtectedRoute>
                    }
                    />
                <Route path="/messageTemplates"
                    element={
                        <ProtectedRoute>
                            <MessageTemplatesPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/emailConnection"
                    element={
                        <ProtectedRoute>
                            <EmailConnectionPage />
                        </ProtectedRoute>
                    }
                />

                <Route path="/reportordersstatus"
                element={
                    <ProtectedRoute>
                        <ReportOrdersStatus />
                    </ProtectedRoute>
                }
                />
                <Route path="/reportreminders"
                    element={
                        <ProtectedRoute>
                            <RemindersPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/reportorderstatusbyassigned"
                    element={
                        <ProtectedRoute>
                            <ReportOrdersStatusByAssigned />
                        </ProtectedRoute>
                    }
                />
                < Route path="/reportnps"
                            element={
                                <ProtectedRoute>
                                    <ReportSurveyNpsPage />
                                </ProtectedRoute>
                            }
                        />
                < Route path="/reportcustomerordersno"
                    element={
                        <ProtectedRoute>
                            <ReportCustomerOrdersNoPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/orderstatus/:orderId"
                    element={
                        <ProtectedRoute>
                            <OrderDetailsPage />
                        </ProtectedRoute>
                    }
                        />

                <Route path="/orderdetailscustomerpage/:orderId"
                    element={
                            <OrderDetailsCustomerPage />
                    }
                />

                <Route path="/orderdetailspage/*" element={<OrderDetailsPage />} />
                <Route path="/countries/*" element={<CountriesPage />} />


                <Route path="/ignorelist"
                    element={
                        <ProtectedRoute>
                            <IgnoreListPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/accountingtranslations"
                    element={
                        <ProtectedRoute>
                            <AccountingTranslationsPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/services"
                    element={
                        <ProtectedRoute>
                            <ServicesPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/ordertypes"
                    element={
                        <ProtectedRoute>
                            <OrderTypesPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/orderstates"
                    element={
                        <ProtectedRoute>
                            <OrderStatesPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/detailstates"
                    element={
                        <ProtectedRoute>
                            <DetailStatesPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/taxtypemappings"
                    element={
                        <ProtectedRoute>
                            <TaxTypeMappingsPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/users"
                    element={
                        <ProtectedRoute>
                            <UsersManagementPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/surveys" element={<SurveyResultsPage />} />

                <Route path="/contacts"
                    element={
                        <ProtectedRoute>
                            <ContactsPage />
                        </ProtectedRoute>
                    }
                />

                <Route path="/customerpricing"
                    element={
                        <ProtectedRoute>
                            <CustomerPricingPage />
                        </ProtectedRoute>
                    }
                />

                <Route path="/service-pricing"
                    element={
                        <ProtectedRoute>
                            <ServicePricingPage />
                        </ProtectedRoute>
                    }
                />


                <Route path="/pricing"
                    element={
                        <ProtectedRoute>
                            <PricingPage />
                        </ProtectedRoute>
                    }
                />

                <Route path="/orders"
                    element={
                        <ProtectedRoute>
                            <OrdersPage />
                        </ProtectedRoute>
                    }
                />
            </Routes>
            </StyledEngineProvider>
            </SnackbarProvider>
            </ThemeProvider>
    );

}

export default App;